<!-- @let pulse = pulseFeature.selectors.pulse.asSignal(); -->
<!-- @let groups = pulse?.groups ?? []; -->
@let isLoading = pulseFeature.selectors.isLoading.asSignal();

<div class="atn-summit-pulse-page">
  <atn-summit-pulse-jumbotron />
  @if (isLoading) {
    <div class="atn-summit-pulse-page__loader">
      <div class="atn-summit-pulse-page__spinner"></div>
    </div>
  } @else {
    <div class="atn-summit-pulse-page__content">
      <!-- Temporary commented out, until is decided whether it should be used or not -->
      <!-- @for (group of groups; track $index) {
      <atn-summit-pulse-highlights [info]="group" />
    } -->
      <atn-summit-pulse-team-spirit />
      <atn-summit-pulse-team-member-overview />
      <!-- <atn-summit-pulse-recommendations
        title="Team Recommendations for Tools & Processes"
        [recommendations]="toolsAndProcesses"
      />
      <atn-summit-pulse-recommendations
        title="Team Recommendations for Courses & Certifications"
        [recommendations]="coursesAndCertifications"
      /> -->
      <!-- Temporary commented out, until is decided whether it should be used or not -->
      <!-- <atn-summit-pulse-outcomes /> -->
      <!-- <atn-summit-pulse-employees /> -->

      <atn-summit-pulse-breakdown />
    </div>
  }
</div>
